import React from "react";
import PropTypes from "prop-types";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";
import DateTimePicker from "../../../../components/DateTimePicker/DateTimePicker";
import { Form } from "semantic-ui-react";
import _format from "date-fns/format";
import { TIME_FORMAT } from "@/sg-schema-form/constants/formats";

function DateTimeWidget({
  id,
  required,
  readonly,
  disabled,
  name,
  label,
  schema,
  value,
  onChange,
  onBlur,
  onFocus,
  autofocus,
  options,
  formContext,
  uiSchema,
  rawErrors = [],
}: any) {
  const { t } = useSchemaTranslation();


  const schemaFormat = schema.format as "date" | "time" | "date-time";

  const {
    minDate,
    maxDate,
    defaultTimeType,
    defaultDateNow,
    maxDateNow,
    minDateNow,
    autoSelectTime = true,
    hourRoundingValue = 0
  } = options

  const oneOfValidFormats = schemaFormat && ["date", "time", "date-time"].includes(schemaFormat);

  if (!oneOfValidFormats && options.format) {
    return <div> [DatePickerWidget]: format in uiSchema is depricated, move format from uiSchema to schema  </div>
  };

  if (!oneOfValidFormats) {
    return <div> [DatePickerWidget]: Schema is missing one of valid format ("date" | "time" | "date-time")  </div>
  };


  const defaultTime = defaultDateNow ? _format(new Date(), TIME_FORMAT) : undefined
  return (
    <Form.Field required={required} disabled={disabled}>
      {label && <label> {t(label)} </label>}
      <DateTimePicker
        key={id}
        value={value}
        onChange={onChange}
        minDate={(minDate === true || minDateNow === true) ? new Date().toISOString() : minDate}
        maxDate={(maxDate === true || maxDateNow === true) ? new Date().toISOString() : maxDate}
        autoSelectTime={autoSelectTime}
        format={schemaFormat}
        error={Boolean(rawErrors && Array.isArray(rawErrors) && rawErrors.length)}
        disabled={disabled || readonly}
        hourRoundingValue={hourRoundingValue}
        defaultTime={defaultTime}
      />
    </Form.Field>
  );


}

DateTimeWidget.defaultProps = {
  options: {
    semantic: {
      fluid: true,
      inverted: false,
    },
  },
};

DateTimeWidget.propTypes = {
  options: PropTypes.object,
};

export default DateTimeWidget